import { render, staticRenderFns } from "./allOrderD.vue?vue&type=template&id=0d974a86&scoped=true&"
import script from "./allOrderD.vue?vue&type=script&lang=js&"
export * from "./allOrderD.vue?vue&type=script&lang=js&"
import style0 from "./allOrderD.vue?vue&type=style&index=0&id=0d974a86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d974a86",
  null
  
)

export default component.exports